module.exports = __webpack_public_path__ + "img/marker-icon-iot-error.0cceb24a.png";